export default __webpack_public_path__ + "static/media/BEKRI_MEHDI_CV.880b8754.pdf";